import React, { useState, forwardRef } from "react";
import { Typography, Paper, Grid, FormControl } from "@material-ui/core";
import useStyles from "../../styles/deviceTaskStyle";
import SelectDevices from "../device/SelectDevices";
import SelectDate from "../device/SelectDate";
import { CommandTextField } from "../commons/Textfields";
import { useTranslation } from "../../langs/useTranslation";
import { Formik, Form } from "formik";
import CommandConfirmDialog from "../commons/CommandConfirmDialog";
import SendRoundedIcon from "@material-ui/icons/SendRounded";
import * as localforage from "localforage";
import { restartSystemAPI } from "../../apis/restartSystemAPI";
import { StyledSubmitBtn, BackBtn } from "../commons/FormBtns";
import {
  handleClose,
  handleHasResponseStatus
} from "../../helpers/commandConfirmationDialogAction";
import {
  GroupOrTagRequiredText,
  ExcelFileRequiredMsg,
  DateTimeComparisonText
} from "../commons/ValidationText";
import {
  restartSystemValuesSchema,
  restartSystemInitialValues
} from "../../config/multiDeviceTaskValuesSchema";

const RestartSystemForm = forwardRef((props, ref) => {
  const classes = useStyles();
  const {
    executeType,
    deviceId,
    storedDeviceValueToLocalforageName,
    storedDatePickerValueToLocalforageName,
    resetAllStoredValueInLocalforage,
    successfulText,
    dispatch
  } = props;
  const { t } = useTranslation("task");
  const [open, setOpen] = useState(false);
  const [values, setValues] = useState({});
  const [selectedIds, setSelectedIds] = useState(true);
  const [datetime, setDatetime] = useState(true);
  const [isExecuting, setIsExecuting] = useState(false);
  const [filterDevicesBy, setFilterDevicesBy] = useState();

  const handleExecuteAction = async () => {
    setIsExecuting(true);
    // Execute the task after modal opened and the confirm button clicked
    const devices = values.devices;
    const command = values.command;
    const responseStatus = await restartSystemAPI(
      deviceId,
      devices,
      selectedIds,
      executeType,
      datetime,
      command,
      t,
      successfulText
    );
    if (responseStatus) {
      handleHasResponseStatus(setOpen, resetAllStoredValueInLocalforage);
    }
    dispatch({ type: "stopLoading" });
  };

  return (
    <Formik
      initialValues={restartSystemInitialValues}
      validationSchema={restartSystemValuesSchema}
      onSubmit={async values => {
        dispatch({ type: "showLoading" });
        setValues(values);
        const selectedIds = await localforage.getItem(
          storedDeviceValueToLocalforageName
        );
        const datetime =
          values.date === "immediately"
            ? "immediately"
            : await localforage.getItem(storedDatePickerValueToLocalforageName);
        setDatetime(datetime);
        setSelectedIds(selectedIds);
        setFilterDevicesBy(values.devices);
        if (datetime && selectedIds) {
          //check if selectedIDs is an empty array
          if (Array.isArray(selectedIds) && selectedIds.length < 1) {
            dispatch({ type: "stopLoading" });
            return;
          }
          setOpen(true);
        } else {
          dispatch({ type: "stopLoading" });
        }
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting
      }) => (
        <Form onSubmit={handleSubmit}>
          <FormControl fullWidth={true} ref={ref}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Paper elevation={0} className={classes.fullWidthPaper}>
                  <Typography variant="h6">
                    {t("task.step")}1. {t("task.selectDevices")}
                  </Typography>
                  <SelectDevices
                    storedDeviceValueToLocalforageName={
                      storedDeviceValueToLocalforageName
                    }
                    formikName="devices"
                    isSubmitting={isSubmitting}
                    formikOnChange={handleChange}
                    formikValue={values.devices}
                    formikError={
                      errors.devices && touched.devices && errors.devices
                    }
                  />
                  {filterDevicesBy !== "excel_import" &&
                  (!selectedIds || selectedIds.length < 1) ? (
                    <GroupOrTagRequiredText />
                  ) : (
                    ""
                  )}
                  {filterDevicesBy === "excel_import" && !selectedIds ? (
                    <ExcelFileRequiredMsg />
                  ) : (
                    ""
                  )}
                </Paper>
                <Paper elevation={0} className={classes.fullWidthPaper}>
                  <Typography variant="h6">
                    {t("task.step")}2. {t("task.selectDate")}
                  </Typography>
                  <SelectDate
                    storedDatePickerValueToLocalforageName={
                      storedDatePickerValueToLocalforageName
                    }
                    formikName="date"
                    formikOnChange={handleChange}
                    formikValue={values.date}
                    formikError={errors.date && touched.date && errors.date}
                  />
                  {!datetime ? <DateTimeComparisonText /> : ""}
                </Paper>
                <Paper elevation={0} className={classes.fullWidthPaper}>
                  <CommandTextField
                    CommandTextFieldPlaceHolder="e.g. taskkill /f /im chrome.exe"
                    formikName="command"
                    formikOnChange={handleChange}
                    formikOnBlur={handleBlur}
                    formikValue={values.command}
                  />
                </Paper>
                <div className="submit-back-btn-wrap">
                  <StyledSubmitBtn
                    startIcon={<SendRoundedIcon />}
                    btnText={t("btn.confirmBtn")}
                    type="submit"
                  />
                  <BackBtn />
                  <CommandConfirmDialog
                    isExecuting={isExecuting}
                    okBtnOnClick={handleExecuteAction}
                    backBtnOnClick={() =>
                      handleClose(setOpen, dispatch, setIsExecuting)
                    }
                    open={open}
                    dialogTitle={t("task.restartSystemName")}
                    dialogContent={t("modal.restartSystemDescription")}
                  />
                </div>
              </Grid>
            </Grid>
          </FormControl>
        </Form>
      )}
    </Formik>
  );
});

export default RestartSystemForm;
